const DOWNLOADING = 'downloading';
const DOWNLOADED = 'downloaded';

export default {
    DOWNLOADED,
    DOWNLOADING,
};
